import { useState, useEffect } from 'react';
import { ConversationKey } from '../models';

export const useSelectFirstConversation = (
    conversationListKeys: ConversationKey[],
    setSelectedConversationKey: (selectedConversationKey?: ConversationKey) => void
) => {
    const [wasFirstConversationSelected, setWasFirstConversationSelected] = useState<boolean>(
        false
    );

    useEffect(() => {
        if (
            !wasFirstConversationSelected &&
            setSelectedConversationKey !== undefined &&
            conversationListKeys.length > 0
        ) {
            setWasFirstConversationSelected(true);
            setSelectedConversationKey(conversationListKeys[0]);
        }
    }, [
        wasFirstConversationSelected,
        conversationListKeys,
        conversationListKeys.length,
        setSelectedConversationKey,
    ]);
};
